{
  "items": [
    {
      "fileName": "GENERIC-PeopleDiverseHome-01.mp4",
      "description": "The video shows one woman, a young adult female with an olive skin tone and dark brown hair styled up into a loose bun, or updo, with a few loose strands of hair framing her face. The woman has dark brown eyes, dark defined eyebrows, and is smiling broadly with her mouth open, showing her white teeth, giving her a warm, friendly, happy visible expression. The woman is wearing a top, a blue, navy blue, button up blouse or shirt patterned with small white polka dots, featuring a collar and a row of visible buttons down the front. The setting is an indoor home or office interior, blurred softly out of focus behind the woman, showing a shelving unit, a wood, light wood or oak colored bookcase, positioned on the left side of the frame holding indistinct light colored objects and books, a plain gray, light gray wall in the middle background, and a bright window on the right side of the frame letting in natural daylight, with a green houseplant, a potted plant with visible leaves, positioned near the window. The lighting is soft, bright, and neutral, appearing to be natural daylight supplemented by ambient indoor lighting, evenly illuminating the woman's face without harsh shadows. The color palette is neutral and muted overall, dominated by navy blue, white, light wood tan, and gray tones, with a small green accent from the houseplant. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or lifestyle stock video with a shallow depth of field, keeping the background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "shelving unit",
        "bookcase",
        "wall",
        "window",
        "potted plant",
        "houseplant",
        "polka dot pattern",
        "lighting"
      ],
      "attributes": [
        "warm",
        "friendly",
        "smiling",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "neutral tone",
        "corporate",
        "lifestyle",
        "woman",
        "blue",
        "navy blue",
        "polka dot",
        "blouse",
        "shirt",
        "shelf",
        "shelving unit",
        "bookcase",
        "wood",
        "oak",
        "window",
        "plant",
        "houseplant",
        "green",
        "wall",
        "gray",
        "white",
        "indoor",
        "home office"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-02.mp4",
      "description": "The video shows one woman, a young adult female with a light olive or tan skin tone, wearing a hijab, a head covering or head scarf, in a blue, light blue, pale blue, and white, ivory color combination, wrapped around her head and neck. The woman has dark brown eyes accentuated with eyeliner, defined dark eyebrows, and pink lipstick, with a soft, gentle smile showing a calm, pleasant visible expression. The woman is wearing a jacket, a blue denim jacket or jean jacket, layered over the scarf fabric that drapes over her shoulders. The setting is an outdoor urban city environment, blurred softly out of focus behind the woman, showing tall city buildings, skyscrapers, and office towers in the background, along with green trees and foliage visible at street level, and a gray, light gray, overcast sky. The lighting is soft, natural, and diffused, consistent with an overcast or hazy daytime sky, evenly lighting the woman's face without strong shadows or highlights. The color palette is cool and muted, dominated by pale blue, ivory, white, gray, and denim blue tones, with green accents from the trees. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame and slightly turned, facing toward the camera. The visual style is photographic, realistic, and resembles a lifestyle or documentary style stock video with a shallow depth of field, keeping the city background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "city buildings",
        "skyscrapers",
        "sky",
        "trees",
        "foliage",
        "denim jacket",
        "scarf",
        "lighting"
      ],
      "attributes": [
        "calm",
        "gentle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "overcast",
        "cool tone",
        "urban",
        "city",
        "lifestyle",
        "woman",
        "hijab",
        "head scarf",
        "headscarf",
        "blue",
        "pale blue",
        "ivory",
        "white",
        "denim",
        "jean jacket",
        "jacket",
        "buildings",
        "skyscraper",
        "trees",
        "foliage",
        "green",
        "sky",
        "gray",
        "outdoor"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-03.mp4",
      "description": "The video shows one man, an older adult male with fair, tan skin, short gray and light brown hair, and light colored eyes, smiling gently with a warm, calm, pleasant visible expression. The man is wearing a sweater, a gray, dark gray knit cardigan or shawl collar sweater with wood colored buttons, layered over a white, light gray t-shirt underneath. The setting is an outdoor natural environment, blurred softly out of focus behind the man, showing dense green foliage, trees, bushes, and leaves filling the entire background with a soft bokeh effect. The lighting is soft, natural, and diffused, consistent with an overcast or shaded outdoor setting, evenly lighting the man's face without harsh shadows. The color palette is earthy and muted, dominated by green, gray, and tan tones, with the man's gray cardigan blending tonally with the muted background. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or documentary style stock video with a shallow depth of field, keeping the green foliage background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "foliage",
        "trees",
        "bokeh",
        "cardigan",
        "sweater",
        "lighting"
      ],
      "attributes": [
        "calm",
        "warm",
        "gentle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "bokeh",
        "soft lighting",
        "natural light",
        "earthy tone",
        "outdoor",
        "nature",
        "lifestyle",
        "man",
        "male",
        "older adult",
        "gray",
        "cardigan",
        "sweater",
        "knit",
        "buttons",
        "t-shirt",
        "tshirt",
        "green",
        "foliage",
        "trees",
        "bushes",
        "leaves"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-04.mp4",
      "description": "The video shows one woman, a young adult female with a tan or olive skin tone and long, dark brown curly hair worn loose past her shoulders. The woman has a nose ring, small gold hoop earrings, and a gold necklace with pearl and bead detailing around her neck, and pink or red colored lipstick. In one visible moment the woman closes her eyes and tilts her face upward with a peaceful, content visible expression, and in another visible moment she opens her eyes and smiles broadly, showing white teeth, looking off to the side with a happy, cheerful visible expression. The woman is wearing a cardigan, a green, mint green cardigan sweater tied at the front, layered over a white, cream colored top underneath. The woman is carrying a bag, a shoulder bag or tote bag with a tan, cream colored strap, and is holding books or notebooks close to her body. The setting is an outdoor urban environment, blurred softly out of focus behind the woman, showing buildings, a red, maroon colored building facade, a palm tree, greenery, and bright sunlight creating lens flare and warm bokeh highlights. The lighting is bright, warm, and natural, consistent with strong sunlight, creating glowing highlights on the woman's hair and skin. The color palette is warm and vibrant, dominated by mint green, cream, tan, gold, and warm brown tones, with red or maroon accents in the background. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a lifestyle or fashion style stock video with a shallow depth of field, keeping the urban background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "buildings",
        "palm tree",
        "greenery",
        "bag",
        "tote bag",
        "books",
        "notebooks",
        "cardigan",
        "lens flare",
        "bokeh",
        "lighting"
      ],
      "attributes": [
        "peaceful",
        "content",
        "happy",
        "cheerful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "lens flare",
        "bokeh",
        "sunlight",
        "natural light",
        "warm tone",
        "vibrant",
        "urban",
        "lifestyle",
        "fashion",
        "woman",
        "curly hair",
        "mint green",
        "green",
        "cardigan",
        "sweater",
        "necklace",
        "earrings",
        "nose ring",
        "bag",
        "tote",
        "books",
        "palm tree",
        "building"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-05.mp4",
      "description": "The video shows one woman, an elderly adult female with a tan or fair skin tone showing visible wrinkles, fine lines, and light brown freckles or age spots across her face. The woman has short, wavy white and gray hair, dark brown eyes, pearl stud earrings, and pink, rose colored lipstick, with a warm, gentle smile giving a kind, friendly visible expression. The woman is wearing a top, a white sleeveless blouse or top, and has a bag with black straps visible over one shoulder. The setting is an outdoor environment, blurred softly out of focus behind the woman, showing indistinct warm toned buildings or walls on the left side of the frame and a cooler toned gray, blue surface on the right side of the frame, with soft glowing highlights suggesting bright sunlight. The lighting is warm, soft, and golden, consistent with late afternoon or early evening sunlight, creating a gentle glow on the woman's white hair and skin. The color palette is warm on one side and cool on the other, dominated by tan, gold, gray, and blue tones, with white from the woman's hair and blouse. The composition is an extreme close up, closeup, head and shoulders framing, with the woman's face filling most of the frame, positioned slightly off center. The visual style is photographic, realistic, and resembles a lifestyle or portrait style stock video with a shallow depth of field, keeping the background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "buildings",
        "wall",
        "bag straps",
        "blouse",
        "lighting",
        "golden light"
      ],
      "attributes": [
        "warm",
        "kind",
        "friendly",
        "gentle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "golden light",
        "soft lighting",
        "natural light",
        "warm tone",
        "cool tone",
        "lifestyle",
        "elderly",
        "woman",
        "senior",
        "gray hair",
        "white hair",
        "wrinkles",
        "freckles",
        "pearl earrings",
        "earrings",
        "white",
        "blouse",
        "bag",
        "strap",
        "outdoor"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-06.mp4",
      "description": "The video shows one woman, a young adult female with a light olive skin tone and medium length, dark brown curly, wavy hair falling just past her shoulders. The woman has dark brown eyes, a small mole or beauty mark near her mouth, and a subtle, soft smile with closed lips, giving a calm, confident visible expression. The woman is wearing a top, a blue, light blue, pale blue crewneck sweater with ribbed detailing at the collar. The setting is an indoor home environment, blurred softly out of focus behind the woman, showing a white, off white wall decorated with several black framed picture frames or art prints displaying black and white photographs, and a red candle along with small decorative objects visible on a shelf or table to the right side of the frame. The lighting is soft, bright, and neutral, consistent with even indoor lighting, illuminating the woman's face evenly without harsh shadows. The color palette is cool and neutral overall, dominated by light blue, white, black, and gray tones, with a small red accent from the candle. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or portrait style stock video with a shallow depth of field, keeping the picture frames and background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "wall",
        "picture frames",
        "art prints",
        "photographs",
        "candle",
        "decorative objects",
        "shelf",
        "sweater",
        "lighting"
      ],
      "attributes": [
        "calm",
        "confident",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "neutral tone",
        "cool tone",
        "indoor",
        "home",
        "lifestyle",
        "woman",
        "curly hair",
        "wavy hair",
        "light blue",
        "blue",
        "sweater",
        "crewneck",
        "picture frame",
        "frame",
        "art print",
        "photograph",
        "black and white",
        "candle",
        "red",
        "wall",
        "gallery wall"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-07.mp4",
      "description": "The video shows one woman, a young adult female with a tan or olive skin tone and dark hair pulled back away from her face. The woman is wearing sunglasses, black framed sunglasses, pushed up on top of her head, along with gold hoop earrings, a small pink heart shaped earring stud, and a pearl, beaded necklace around her neck. The woman has a confident, slightly serious visible expression with her lips closed and head tilted, looking directly toward the camera. The woman is wearing a sweater, a knit sweater in a color block, colorblock pattern of white, cream, orange, blue, and pink stripes, layered over an orange tank top underneath. The setting is an outdoor environment on a bridge or pier, blurred softly out of focus behind the woman, showing a concrete railing or barrier, distant city buildings, a tall pole or light post, and a bright, hazy white sky. The lighting is bright, warm, and sunny, with strong sunlight creating a glowing, hazy highlight effect around the woman's hair and shoulders. The color palette is bright and warm, dominated by orange, pink, light blue, cream, and white tones, with muted gray and tan tones in the distant buildings. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a fashion or lifestyle style stock video with a shallow depth of field, keeping the bridge and city background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "bridge",
        "railing",
        "buildings",
        "sky",
        "sweater pattern",
        "sunglasses",
        "lighting",
        "sun flare"
      ],
      "attributes": [
        "confident",
        "serious",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "sun flare",
        "hazy",
        "bright lighting",
        "natural light",
        "warm tone",
        "vibrant",
        "fashion",
        "lifestyle",
        "woman",
        "sunglasses",
        "colorblock",
        "color block",
        "stripes",
        "orange",
        "pink",
        "blue",
        "cream",
        "white",
        "sweater",
        "knit",
        "tank top",
        "earrings",
        "necklace"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-08.mp4",
      "description": "The video shows one woman, a young adult female with a tan or olive skin tone and long, dark brown wavy, curly hair falling past her shoulders. The woman has dark brown eyes and is smiling broadly with her mouth open, showing white teeth, giving a joyful, happy, energetic visible expression. The woman is wearing a top, a yellow, bright yellow crewneck t-shirt. The setting is an outdoor city street environment, blurred softly out of focus behind the woman, showing light colored buildings, a white van or car parked along the street, and a paved road or sidewalk. The lighting is bright and natural, consistent with daytime sunlight, evenly illuminating the woman's face and creating warm highlights on her skin and hair. The color palette is warm and bright, dominated by yellow, tan, white, and beige tones. The composition is a tight close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a shallow depth of field, keeping the street and vehicle background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "buildings",
        "van",
        "car",
        "street",
        "sidewalk",
        "shirt",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "happy",
        "energetic",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "sunny",
        "warm tone",
        "casual",
        "lifestyle",
        "woman",
        "yellow",
        "t-shirt",
        "tshirt",
        "curly hair",
        "wavy hair",
        "van",
        "car",
        "vehicle",
        "street",
        "buildings",
        "outdoor",
        "city"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-09.mp4",
      "description": "The video shows one man, a young adult male with a tan or olive skin tone, short dark curly hair, and a thin mustache along with light stubble or a short goatee on his chin. The man is smiling broadly with his mouth open, showing white teeth, giving a joyful, happy, energetic visible expression, with visible smile lines near his eyes. The man is wearing a shirt, a blue denim button up shirt with a collar, layered over a plain white t-shirt underneath. The setting is an outdoor narrow street or alleyway environment, blurred softly out of focus behind the man, showing tan, beige colored buildings with columns or pillars lining the street, and a small green trash bin, waste bin visible on the left side of the frame. The lighting is soft and diffused, consistent with an overcast or shaded daytime setting, evenly illuminating the man's face without harsh shadows. The color palette is warm and neutral, dominated by tan, beige, blue denim, and white tones, with a small green accent from the trash bin. The composition is a tight close up, closeup, head and shoulders framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a shallow depth of field, keeping the alleyway and buildings background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "buildings",
        "columns",
        "alleyway",
        "street",
        "trash bin",
        "waste bin",
        "shirt",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "happy",
        "energetic",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "overcast",
        "warm tone",
        "casual",
        "lifestyle",
        "man",
        "male",
        "mustache",
        "goatee",
        "stubble",
        "curly hair",
        "denim",
        "blue",
        "shirt",
        "t-shirt",
        "tshirt",
        "buildings",
        "columns",
        "alleyway",
        "trash bin",
        "green"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-10.mp4",
      "description": "The video shows two people, one woman and one girl, in an indoor home living room setting. The woman is an adult female with fair skin and long, wavy blonde hair, smiling broadly with her mouth open, showing white teeth, giving a joyful, cheerful, happy visible expression, and has one arm raised upward as if taking a selfie photograph or waving, revealing a small black line tattoo, a branch, floral tattoo design, on her forearm. The woman is wearing a top, a blue, light blue, gray button up shirt with a tie detail at the sleeve. The girl is a young child with fair skin, curly blonde hair, and light blue eyes, with a calm, neutral, serious visible expression, wearing a top, a white shirt with a small floral pattern, and small stud earrings. The girl is positioned in front of the woman, sitting closer to the camera, while the woman leans over her from behind. The setting is an indoor home living room, showing a gray sofa, couch with a yellow throw pillow and a white, cream colored throw pillow, blue, gray curtains hanging near a bright window on the left side of the frame, a white dresser, cabinet in the background, and a framed abstract art print hanging on the wall. The lighting is soft, bright, and natural, consistent with daylight coming through the window, evenly illuminating both the woman and the girl. The color palette is soft and neutral, dominated by light blue, gray, white, and cream tones, with a yellow accent from the throw pillow. The composition is a medium close up, closeup, upper body framing, shot from a slightly low selfie style angle, with both the woman and the girl positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a candid, lifestyle, family style stock video with a natural, unposed feel.",
      "keyElements": [
        "sofa",
        "couch",
        "throw pillow",
        "curtains",
        "window",
        "dresser",
        "cabinet",
        "art print",
        "wall",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "cheerful",
        "happy",
        "calm",
        "neutral",
        "candid",
        "selfie",
        "portrait",
        "medium close up",
        "closeup",
        "natural light",
        "soft lighting",
        "family",
        "lifestyle",
        "woman",
        "girl",
        "child",
        "mother",
        "daughter",
        "blonde hair",
        "curly hair",
        "wavy hair",
        "tattoo",
        "sofa",
        "couch",
        "throw pillow",
        "yellow",
        "cream",
        "curtains",
        "blue",
        "gray",
        "window",
        "dresser",
        "art print",
        "living room"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-11.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone, light freckles, and long, red, ginger colored curly, wavy hair that moves dynamically in the wind, catching bright backlight that creates a warm, glowing halo effect around her hair. The woman has light blue eyes, pink lipstick, and is smiling broadly with her mouth open, showing white teeth, giving a joyful, energetic, happy visible expression, with one hand raised near her shoulder in a clenched, playful gesture, revealing a black watch, bracelet on her wrist. The woman is wearing a top, a green, dark green ribbed turtleneck sweater. The setting is an outdoor city street environment, blurred softly out of focus behind the woman, showing a crowd of people, pedestrians walking along a wide street or plaza, tall city buildings, and a bright, hazy white sky with strong backlight sunlight creating lens flare. The lighting is bright, warm, and golden, consistent with strong sunlight shining from behind the woman, creating glowing highlights through her hair. The color palette is warm and vibrant, dominated by red, orange, gold, and green tones, with muted gray and tan tones from the distant buildings and crowd. The composition is a medium close up, closeup, upper body framing, with the woman positioned slightly off center in the frame. The visual style is photographic, realistic, and resembles a lifestyle or fashion style stock video with a shallow depth of field, keeping the crowd and buildings background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "crowd",
        "pedestrians",
        "buildings",
        "street",
        "sky",
        "sweater",
        "lens flare",
        "watch",
        "bracelet"
      ],
      "attributes": [
        "joyful",
        "energetic",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "lens flare",
        "backlight",
        "golden light",
        "bright lighting",
        "natural light",
        "warm tone",
        "vibrant",
        "urban",
        "city",
        "lifestyle",
        "fashion",
        "woman",
        "red hair",
        "ginger hair",
        "curly hair",
        "wavy hair",
        "freckles",
        "green",
        "turtleneck",
        "sweater",
        "watch",
        "bracelet",
        "crowd",
        "pedestrians",
        "buildings"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-12.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone, light hazel, green eyes, and long, straight, blonde, light brown hair that partially covers her face. The woman is wearing a hood, a brown, dark brown hooded garment or jacket pulled up over her head, framing her face closely. The woman has a soft, subtle smile with closed lips, giving a calm, gentle visible expression, and in one visible moment she closes her eyes, tilting her face slightly downward with a peaceful, relaxed visible expression. The setting is an outdoor urban environment, blurred heavily out of focus behind the woman, showing indistinct light colored buildings, warm toned architecture, and soft bokeh highlights suggesting distant lights or reflections. The lighting is soft and neutral, consistent with overcast or diffused daylight, evenly illuminating the woman's face without harsh shadows. The color palette is warm and muted, dominated by blonde, tan, brown, and beige tones, with soft warm bokeh highlights in the background. The composition is an extreme close up, closeup, tight face framing, with the woman's face filling nearly the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a beauty or lifestyle style stock video with a shallow depth of field, keeping the background heavily blurred while the woman's face remains in sharp focus.",
      "keyElements": [
        "buildings",
        "bokeh",
        "hood",
        "hooded garment",
        "lighting"
      ],
      "attributes": [
        "calm",
        "gentle",
        "peaceful",
        "relaxed",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "bokeh",
        "soft lighting",
        "natural light",
        "overcast",
        "warm tone",
        "muted tone",
        "beauty",
        "lifestyle",
        "woman",
        "blonde hair",
        "light brown hair",
        "straight hair",
        "hazel eyes",
        "green eyes",
        "hood",
        "hooded jacket",
        "brown",
        "tan",
        "beige",
        "buildings",
        "outdoor"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-13.mp4",
      "description": "The video shows one man, a middle aged adult male with a tan or light skin tone, short dark hair styled upward, and dark brown eyes, smiling broadly with his mouth open, showing white teeth, and visible smile lines near his eyes, giving a warm, friendly, joyful visible expression. The man is wearing a top, a blue, navy blue button up shirt with a mandarin, stand up collar. The setting is an indoor home living room environment, blurred softly out of focus behind the man, showing wood paneling on the wall, a dark colored shelving unit or cabinet holding a round white plate, a green potted plant, books, and small decorative objects, along with a bright window on the left side of the frame with a green plant visible near the light, and a light colored sofa or couch in the foreground. The lighting is bright, warm, and natural, consistent with daylight streaming through the window, evenly illuminating the man's face and creating warm highlights. The color palette is warm and neutral, dominated by navy blue, tan, wood brown, and white tones, with green accents from the plants. The composition is a medium close up, closeup, upper body framing, with the man centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a corporate or lifestyle style stock video with a shallow depth of field, keeping the living room background softly blurred while the man remains in sharp focus.",
      "keyElements": [
        "wood paneling",
        "shelving unit",
        "cabinet",
        "plate",
        "potted plant",
        "books",
        "decorative objects",
        "window",
        "sofa",
        "couch",
        "lighting"
      ],
      "attributes": [
        "warm",
        "friendly",
        "joyful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "neutral tone",
        "corporate",
        "lifestyle",
        "man",
        "male",
        "middle aged",
        "navy blue",
        "blue",
        "shirt",
        "mandarin collar",
        "wood paneling",
        "shelving unit",
        "cabinet",
        "plate",
        "plant",
        "books",
        "window",
        "sofa",
        "couch",
        "living room"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-14.mp4",
      "description": "The video shows one woman, a young adult female with a dark, deep brown skin tone and short, curly, coily afro hairstyle, styled naturally around her head. The woman has gold, yellow eye makeup applied around her eyes, and a calm, confident, slightly serious visible expression with her lips closed, looking downward and off to the side. The woman is wearing a jacket, an oversized blue, light blue denim jacket, layered over a cropped denim, dark colored top, revealing her midriff, along with yellow pants, a silver chain necklace, and rings on her fingers. The woman is holding a skateboard, a skateboard with a dark, patterned deck and pink wheels, positioned at her side. The setting is an outdoor environment, shot from a low angle looking upward, showing a bright blue sky with soft white clouds, and a tall white, cream colored cable stayed bridge with diagonal support cables radiating behind the woman. The lighting is bright and natural, consistent with clear daytime sunlight, creating strong contrast between the woman and the bright sky. The color palette is bright and bold, dominated by blue, denim blue, yellow, and gold tones, with white from the bridge and clouds. The composition is a low angle, wide shot, full body framing, with the woman positioned in the center left of the frame against the open sky. The visual style is photographic, realistic, and resembles a fashion or urban lifestyle style stock video with a sharp, high contrast look.",
      "keyElements": [
        "sky",
        "clouds",
        "bridge",
        "support cables",
        "skateboard",
        "denim jacket",
        "necklace",
        "rings",
        "lighting"
      ],
      "attributes": [
        "confident",
        "calm",
        "serious",
        "candid",
        "portrait",
        "low angle",
        "wide shot",
        "full body",
        "high contrast",
        "bright lighting",
        "natural light",
        "bold color",
        "vibrant",
        "urban",
        "fashion",
        "lifestyle",
        "woman",
        "afro hair",
        "curly hair",
        "coily hair",
        "denim jacket",
        "denim",
        "blue",
        "yellow",
        "gold",
        "skateboard",
        "necklace",
        "chain",
        "rings",
        "sky",
        "clouds",
        "bridge",
        "cables"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-15.mp4",
      "description": "The video shows an extreme macro close up of one person's eyes and upper face, an elderly adult with a fair, tan skin tone showing deep set wrinkles, fine lines, and visible skin texture around the eyes and forehead. The person has light blue, gray eyes, and gray, white eyebrows and hair visible at the edges of the frame, with a calm, neutral, still visible expression, looking directly toward the camera. The setting is an indoor environment with a plain, muted gray background, blurred and softly out of focus, giving no additional visual context beyond the person's face. The lighting is soft, warm, and directional, coming from one side of the face, creating gentle shadows and highlights that emphasize the texture and depth of the skin and wrinkles. The color palette is warm and muted, dominated by tan, beige, gray, and light pink skin tones. The composition is an extreme close up, closeup, macro framing, with the eyes and upper face filling the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a documentary or beauty style stock video with a shallow depth of field and detailed macro focus on skin texture.",
      "keyElements": ["background", "lighting", "shadow", "highlight"],
      "attributes": [
        "calm",
        "neutral",
        "still",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "macro",
        "shallow depth of field",
        "soft lighting",
        "warm tone",
        "muted tone",
        "documentary",
        "beauty",
        "elderly",
        "senior",
        "eyes",
        "gray eyes",
        "blue eyes",
        "wrinkles",
        "skin texture",
        "eyebrows",
        "gray hair",
        "white hair",
        "gray background",
        "shadow",
        "highlight"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-16.mp4",
      "description": "The video shows one woman, an elderly adult female with a fair skin tone and short, white, silver, gray bob hairstyle. The woman has dark brown eyes, visible wrinkles and fine lines, pearl stud earrings, and pink, rose colored lipstick, with a warm, gentle smile showing white teeth, giving a kind, friendly, happy visible expression. The woman is wearing a top, a blue, light blue denim button up shirt with small white polka dots and a collar. The setting is an indoor home environment, blurred softly out of focus behind the woman, showing a plain blue, gray wall, a green plant in a vase on the left side of the frame, and a wooden shelf or cabinet holding indistinct light colored objects and boxes on the right side of the frame. The lighting is soft, bright, and neutral, consistent with even indoor lighting, illuminating the woman's face evenly without harsh shadows. The color palette is cool and neutral overall, dominated by light blue, gray, white, and tan tones, with a green accent from the plant. The composition is a medium close up, closeup, head and shoulders framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or portrait style stock video with a shallow depth of field, keeping the background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "wall",
        "plant",
        "vase",
        "shelf",
        "cabinet",
        "polka dot pattern",
        "lighting"
      ],
      "attributes": [
        "warm",
        "kind",
        "friendly",
        "happy",
        "gentle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "neutral tone",
        "cool tone",
        "lifestyle",
        "elderly",
        "woman",
        "senior",
        "gray hair",
        "white hair",
        "silver hair",
        "bob hairstyle",
        "pearl earrings",
        "earrings",
        "denim",
        "blue",
        "polka dot",
        "shirt",
        "plant",
        "vase",
        "shelf",
        "cabinet"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-17.mp4",
      "description": "The video shows one woman, a young adult female with a light to medium brown skin tone and short, curly, coily afro hairstyle. The woman has dark brown eyes, large silver hoop earrings, and pink lipstick, with a broad, open mouthed smile showing white teeth, giving a joyful, warm, friendly visible expression. The woman is wearing a top, a blue denim button up shirt with a collar and front pockets. The setting is an indoor cafe or restaurant environment, blurred softly out of focus behind the woman, showing a tiled wall in tan, beige tones, wooden shelves holding indistinct bottles, jars, and small decorative objects, hanging pendant lights glowing warmly above, a small potted plant on the upper left, and a dark chalkboard sign with a coffee cup illustration on the right side of the frame. The lighting is warm and glowing, consistent with the hanging pendant lights and ambient indoor lighting, creating a cozy, warm atmosphere on the woman's face. The color palette is warm and rich, dominated by tan, beige, brown, and denim blue tones, with warm yellow and orange glowing light accents. The composition is a medium close up, closeup, upper body framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or hospitality style stock video with a shallow depth of field, keeping the cafe background softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "tiled wall",
        "shelves",
        "pendant lights",
        "potted plant",
        "chalkboard sign",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "friendly",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "warm lighting",
        "cozy",
        "glowing light",
        "lifestyle",
        "hospitality",
        "cafe",
        "woman",
        "afro hair",
        "curly hair",
        "coily hair",
        "hoop earrings",
        "earrings",
        "denim",
        "blue",
        "shirt",
        "tiled wall",
        "shelves",
        "pendant light",
        "plant",
        "chalkboard",
        "coffee cup"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-18.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone, visible freckles across her face, and long, red, ginger colored curly hair that frames her face densely on both sides. The woman has her eyes closed, with dark eyelashes visible, and a calm, subtle, neutral visible expression with her lips closed, tilting her face slightly downward. The setting is an indoor or shaded outdoor environment with a dark teal, blue green blurred background, softly out of focus, giving no additional visual context beyond the woman's face and hair. The lighting is warm and directional, coming from one side of the face, creating a warm glow on the woman's skin and hair while the background remains cool toned and dim. The color palette contrasts warm and cool tones, dominated by red, orange, and warm skin tones in the foreground against a teal, dark blue green background. The composition is an extreme close up, closeup, tight face framing, with the woman's face and hair filling nearly the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a beauty or portrait style stock video with a shallow depth of field and soft, moody lighting.",
      "keyElements": ["background", "backlighting", "lighting"],
      "attributes": [
        "calm",
        "neutral",
        "subtle",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "moody lighting",
        "warm tone",
        "cool tone",
        "teal background",
        "beauty",
        "portrait style",
        "woman",
        "red hair",
        "ginger hair",
        "curly hair",
        "freckles",
        "closed eyes",
        "eyelashes",
        "teal",
        "blue green",
        "warm light"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-19.mp4",
      "description": "The video shows one woman, a young adult female with a fair skin tone, visible freckles across her face, and long, red, ginger colored curly hair that frames her face densely on both sides. The woman is smiling broadly with her mouth open, showing white teeth, and her eyes squinted, partially closed from smiling, giving a joyful, happy, cheerful visible expression. The setting is an indoor or shaded outdoor environment with a dark teal, blue green blurred background, softly out of focus, giving no additional visual context beyond the woman's face and hair. The lighting is warm and directional, coming from one side of the face, creating a warm glow on the woman's skin and hair while the background remains cool toned and dim. The color palette contrasts warm and cool tones, dominated by red, orange, and warm skin tones in the foreground against a teal, dark blue green background. The composition is an extreme close up, closeup, tight face framing, with the woman's face and hair filling nearly the entire frame, centered directly toward the camera. The visual style is photographic, realistic, and resembles a beauty or portrait style stock video with a shallow depth of field and soft, warm lighting.",
      "keyElements": ["background", "backlighting", "lighting"],
      "attributes": [
        "joyful",
        "happy",
        "cheerful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "warm lighting",
        "warm tone",
        "cool tone",
        "teal background",
        "beauty",
        "portrait style",
        "woman",
        "red hair",
        "ginger hair",
        "curly hair",
        "freckles",
        "smiling",
        "teeth",
        "teal",
        "blue green"
      ]
    },
    {
      "fileName": "GENERIC-PeopleDiverseHome-20.mp4",
      "description": "The video shows one woman, a young adult female with a medium brown skin tone and shoulder length, curly, coily dark brown hair. The woman is wearing eyeglasses, clear, transparent framed eyeglasses, and has green eye makeup applied around her eyes, with a broad, open mouthed smile showing white teeth, giving a joyful, happy, cheerful visible expression. The woman is wearing a top, a blue and white pinstripe, striped button up shirt layered over a white top underneath, along with a thin silver necklace. The setting is an outdoor park or plaza environment, showing tall, ornate sandstone, stone colored pillars, columns forming a gate or entrance structure, a black wrought iron fence, green trees in the distance, and a paved walkway or plaza surface, with a person riding a red bicycle blurred in the background on the left side of the frame. The lighting is soft and diffused, consistent with an overcast or early evening daylight setting, evenly illuminating the woman's face without harsh shadows. The color palette is muted and cool, dominated by tan, sandstone, green, blue, and white tones, with a small red accent from the bicycle in the background. The composition is a medium close up, closeup, upper body framing, with the woman centered in the frame facing the camera directly. The visual style is photographic, realistic, and resembles a lifestyle or casual portrait style stock video with a moderate depth of field, keeping the background recognizable but softly blurred while the woman remains in sharp focus.",
      "keyElements": [
        "pillars",
        "columns",
        "fence",
        "trees",
        "walkway",
        "plaza",
        "bicycle",
        "eyeglasses",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "happy",
        "cheerful",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "moderate depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "overcast",
        "muted tone",
        "cool tone",
        "casual",
        "lifestyle",
        "woman",
        "curly hair",
        "coily hair",
        "eyeglasses",
        "glasses",
        "green eye makeup",
        "striped shirt",
        "pinstripe",
        "blue",
        "white",
        "necklace",
        "pillars",
        "columns",
        "fence",
        "trees",
        "bicycle",
        "plaza",
        "park"
      ]
    }
  ]
}
